import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NetworkStatusService } from '@core/network/network-status.service';
import { Observable, map, startWith } from 'rxjs';
import { NetworkStatus } from '@core/network/network-status.service';
import { getConnectionStatusMessage } from '@core/network/network-error.utils';

@Component({
    selector: 'wai-connection-status',
    imports: [CommonModule, MatIconModule],
    template: `
    <ng-container *ngIf="networkStatus$ | async as _networkStatus">
      <ng-container *ngIf="asNetworkStatus(_networkStatus) as networkStatus">
        <div
          class="connection-status"
          [class.visible]="showStatus$ | async"
          [class.offline]="!networkStatus?.isOnline"
        >
          <div class="status-content">
            <mat-icon class="status-icon">
              {{ networkStatus?.isOnline ? 'wifi' : 'wifi_off' }}
            </mat-icon>
            <span class="status-text">
              {{ getStatusMessage(networkStatus?.isOnline) }}
            </span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  `,
    styles: [
        `
      .connection-status {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.9);
        color: white;
        padding: 12px 24px;
        transform: translateY(100%);
        transition: transform 0.3s ease;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .connection-status.visible {
        transform: translateY(0);
      }

      .connection-status.offline {
        background: rgba(244, 67, 54, 0.95);
      }

      .status-content {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 500;
      }

      .status-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
      }

      .status-text {
        white-space: nowrap;
      }

      @media (max-width: 768px) {
        .connection-status {
          padding: 8px 16px;
        }

        .status-text {
          font-size: 12px;
        }
      }
    `,
    ]
})
export class ConnectionStatusComponent implements OnInit {
  public networkStatus$: Observable<NetworkStatus>;
  public showStatus$: Observable<boolean>;
  public asNetworkStatus = (x: unknown): NetworkStatus => x as NetworkStatus;

  constructor(private networkStatusService: NetworkStatusService) {
    this.networkStatus$ = this.networkStatusService.networkStatus$;

    // Only show status when there are connection issues or when transitioning
    this.showStatus$ = this.networkStatus$.pipe(
      map((status) => !status.isOnline),
      startWith(false),
    );
  }

  ngOnInit(): void {
    // Component is ready
  }

  getStatusMessage(isOnline: boolean | undefined): string {
    if (isOnline === undefined) return '';
    return getConnectionStatusMessage(isOnline).message;
  }
}
